import React, { Component } from "react";
import { Modal, Radio, Alert, message } from "antd";
import { BulbOutlined } from "@ant-design/icons";
import { SelectEmpleadosItem } from "../../../../Components/Items";
import { cmmsPost } from "../cmmsComun";
import "../cmms.css";

// "Sugerir a...": a quien se le sugiere lo que falta por calendarizar. Para todos (cualquier
// ingeniero lo ve en su agenda) o para uno solo. No pone fecha ni crea la Orden de Servicio.
// planesIds: renglones sin fecha de un contrato. activosIds: equipos sin contrato.
// onListo() despues de guardar.
class ModalSugerirCMMS extends Component {
    state = { para: "todos", empleadoId: null, guardando: false };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) {
            const inicial = this.props.empleadoInicial || null;
            this.setState({ para: inicial ? "uno" : "todos", empleadoId: inicial, guardando: false });
        }
    }

    aceptar = async () => {
        const { planesIds = [], activosIds = [] } = this.props;
        const empleadoId = this.state.para === "uno" ? this.state.empleadoId : null;
        this.setState({ guardando: true });
        try {
            const res = await cmmsPost(this.props, "sugerirCMMS", { planesIds, activosIds, empleadoId });
            if (res.data.success === 2) {
                const { actualizados, omitidos } = res.data;
                message.success(`${actualizados} sugerido(s) ${empleadoId ? "al ingeniero" : "a todos"}${omitidos ? ` · ${omitidos} omitido(s): ya tenían fecha o su contrato está cancelado` : ""}`);
                this.props.onListo();
            } else message.error(res.data.message || "No se pudo guardar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar");
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const { visible, cantidad, nota, planesIds = [], activosIds = [] } = this.props;
        const { para, empleadoId } = this.state;
        const nada = !planesIds.length && !activosIds.length;
        return (
            <Modal
                className="cmms-modal"
                visible={visible}
                onCancel={this.props.onCancel}
                onOk={this.aceptar}
                okText="Aceptar"
                cancelText="Cancelar"
                confirmLoading={this.state.guardando}
                okButtonProps={{ disabled: nada || (para === "uno" && !empleadoId) }}
                width={window.innerWidth > 700 ? 480 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        <BulbOutlined style={{ fontSize: 20, color: "#d9962b" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">Sugerir a...</div>
                            <div className="cmms-modal-subtitulo">
                                {cantidad > 1 ? `${cantidad} equipos seleccionados. ` : ""}Sin fecha: el ingeniero lo ve en su agenda y en Mis servicios para calendarizarlo.
                            </div>
                        </div>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo" style={{ paddingBottom: 12 }}>
                    {nota ? <Alert type={nada ? "warning" : "info"} showIcon message={nota} style={{ marginBottom: 10 }} /> : null}
                    <Radio.Group value={para} onChange={(e) => this.setState({ para: e.target.value })} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                        <Radio value="todos">
                            <b>A todos los ingenieros</b>
                            <div className="cmms-ayuda" style={{ margin: 0 }}>Le aparece a cualquier ingeniero en su agenda.</div>
                        </Radio>
                        <Radio value="uno">
                            <b>A un ingeniero</b>
                            <div className="cmms-ayuda" style={{ margin: 0 }}>Sólo le aparece a él; a los demás ingenieros ya no.</div>
                        </Radio>
                    </Radio.Group>
                    {para === "uno" && (
                        <div style={{ marginTop: 10 }}>
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                width="100%"
                                placeholder="Elija el ingeniero"
                                value={empleadoId || undefined}
                                onChange={(id) => this.setState({ empleadoId: id || null })}
                            />
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
}

export default ModalSugerirCMMS;
